import { injectBaseConstantMethods } from "./BaseConstants";

export const NOTIFICATION_TYPE = {
    RECOMMENDATION: "RECOMMENDATION",
    PROMOTION: "PROMOTION"
};

const displayTextKeys = {
    [NOTIFICATION_TYPE.RECOMMENDATION]: "Recommendation",
    [NOTIFICATION_TYPE.PROMOTION]: "Promotional"
};

const labelClass = {
    [NOTIFICATION_TYPE.RECOMMENDATION]: "cs-badge-recommendation",
    [NOTIFICATION_TYPE.PROMOTION]: "cs-badge-promotional"
};

export default injectBaseConstantMethods(NOTIFICATION_TYPE, displayTextKeys, labelClass);
